import React, {useMemo} from "react";
import Stepper from "../../../../../../../components/app-specific/stepper";
import {PrintCatalogueViewSteps} from "../../index";

const PrintCatalogueViewStepperSection = ({
                                              productSelectionState,
                                              configureGroupsState,
                                              reviewState,
                                              step,
                                              setStep,
                                              updatingStep,
                                          }) => {

    const steps = useMemo(() => {
        const result = [
            {id: PrintCatalogueViewSteps.productSelection},
            {id: PrintCatalogueViewSteps.configureGroups},
            {id: PrintCatalogueViewSteps.review},
        ]
        const changedLabels = {
            [PrintCatalogueViewSteps.productSelection]: [
                !productSelectionState.selectedCategories?.length ? '' : `${productSelectionState.selectedCategories?.length ?? 0} Categor${(productSelectionState.selectedCategories?.length ?? 0) === 1 ? 'y' : 'ies'}`,
                !productSelectionState.selectedProducts?.length ? '' : `${productSelectionState.selectedProducts?.length ?? 0} Product${(productSelectionState.selectedProducts?.length ?? 0) === 1 ? '' : 's'}`,
                !productSelectionState.selectedTags?.length ? '' : `${productSelectionState.selectedTags?.length ?? 0} Tag${(productSelectionState.selectedTags?.length ?? 0) === 1 ? '' : 's'}`,
            ]
                .filter(Boolean)
                .join('and').concat(' selected'),
            [PrintCatalogueViewSteps.configureGroups]: `${configureGroupsState.categories.length} Categor${configureGroupsState.categories.length === 1 ? 'y' : 'ies'}`
                + ' and '
                + `${configureGroupsState.makes.length} Make${configureGroupsState.makes.length === 1 ? '' : 's'}`
                + ' and '
                + `${configureGroupsState.tags.length} Tag${configureGroupsState.tags.length === 1 ? '' : 's'}`,
            [PrintCatalogueViewSteps.review]: reviewState.products.length + ' Product' + (reviewState.products.length === 1 ? '' : 's') + ' selected',
        }
        const defaultLabels = {
            [PrintCatalogueViewSteps.productSelection]: 'Select Products',
            [PrintCatalogueViewSteps.configureGroups]: 'Configure Groups',
            [PrintCatalogueViewSteps.review]: 'Review and Finalize',
        }
        const stepPassed = {
            [PrintCatalogueViewSteps.productSelection]: step === PrintCatalogueViewSteps.configureGroups || step === PrintCatalogueViewSteps.review,
            [PrintCatalogueViewSteps.configureGroups]: step === PrintCatalogueViewSteps.review,
            [PrintCatalogueViewSteps.review]: false,
        }
        const stepsDisabledStatus = {
            [PrintCatalogueViewSteps.productSelection]: step === PrintCatalogueViewSteps.review || (!productSelectionState.selectedTags.length && !productSelectionState.selectedCategories.length && !productSelectionState.selectedProducts.length),
            [PrintCatalogueViewSteps.configureGroups]: !configureGroupsState.categories.length,
            [PrintCatalogueViewSteps.review]: step === PrintCatalogueViewSteps.productSelection || step === PrintCatalogueViewSteps.configureGroups,
        }
        return result.map(e => ({
            id: e.id,
            label: stepPassed[e.id] ? changedLabels[e.id] : defaultLabels[e.id],
            disabled: stepsDisabledStatus[e.id] || updatingStep,
        }));
    }, [configureGroupsState.categories.length, configureGroupsState.makes.length, configureGroupsState.tags.length, productSelectionState.selectedCategories.length, productSelectionState.selectedProducts?.length, productSelectionState.selectedTags.length, reviewState.products.length, step, updatingStep])

    return (
        <Stepper
            steps={steps}
            activeStepId={step}
            onClicked={setStep}
            className={'w-75 my-5'}
        />
    );
};

export default PrintCatalogueViewStepperSection;
